/* Wolf Eyes product page: gallery (crossfade desktop / swipe mobile), variant
   selection, spec table, related rail, mobile sticky buy bar. */
(function () {
  var root = document.querySelector('.wp');
  if (!root) return;

  var data = document.getElementById('wp-variants');
  var variants = [];
  try { variants = JSON.parse(data.textContent); } catch (e) { return; }

  var input = root.querySelector('[data-variant-input]');
  /* there are two add buttons on mobile - the in-flow one and the sticky bar -
     so every state change has to reach both. */
  var addBtns = root.querySelectorAll('[data-add]');
  var addTexts = root.querySelectorAll('[data-add-text]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var saveEl = root.querySelector('[data-save]');
  var badgeEl = root.querySelector('[data-badge]');
  var track = root.querySelector('.wp-track');
  var stage = root.querySelector('.wp-stage');

  var mq = window.matchMedia('(max-width: 600px)');

  var money = root.dataset.moneyFormat ||
              (window.Shopify && window.Shopify.money_format) || '';
  var currency = (window.Shopify && window.Shopify.currency &&
                  window.Shopify.currency.active) || 'INR';

  function setAdd(disabled, label) {
    addBtns.forEach(function (b) { b.disabled = disabled; });
    addTexts.forEach(function (t) { t.textContent = label; });
  }

  function formatMoney(cents) {
    var value = cents / 100;
    if (money) {
      var str = value.toFixed(2).replace(/\.00$/, '');
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money
        .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
    }
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: currency, maximumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return '₹' + Math.round(value).toLocaleString('en-IN');
    }
  }

  /* ---------- description: build the spec table ---------- */
  (function dressDescription() {
    var desc = root.querySelector('[data-desc]');
    if (!desc) return;

    desc.querySelectorAll('ul').forEach(function (list) {
      var rows = [].slice.call(list.children).map(function (li) {
        var text = li.textContent.trim();
        var at = text.indexOf(':');
        return at === -1
          ? { key: '', val: text }
          : { key: text.slice(0, at).trim(), val: text.slice(at + 1).trim() };
      });
      if (!rows.some(function (r) { return r.key; })) return;

      var table = document.createElement('div');
      table.className = 'wp-spec';
      table.innerHTML = rows.map(function (r) {
        return '<div class="wp-spec-row"><span class="wp-spec-key">' + r.key +
               '</span><span class="wp-spec-val">' + r.val + '</span></div>';
      }).join('');
      list.replaceWith(table);

      /* the copy already lists the frame reference, so drop our duplicate line */
      if (rows.some(function (r) { return /frame reference/i.test(r.key); })) {
        var dup = root.querySelector('[data-sku-wrap]');
        if (dup) dup.remove();
      }
    });
  })();

  /* read these AFTER dressDescription, which may have removed the node */
  var skuWrap = root.querySelector('[data-sku-wrap]');
  var skuEl = root.querySelector('[data-sku]');

  /* ---------- gallery ----------
     Each colourway ships four shots named wolf-eyes-<model>-<colour>-<n>.jpg,
     and Shopify keeps the filename in the CDN URL. Group by that stem so
     choosing Teal shows the four teal shots, not all sixteen across every
     colour. If a product does not follow the scheme, show everything. */
  function colourGroup(src) {
    var file = String(src || '').split('/').pop().split('?')[0];
    var m = file.match(/^(.+)-\d+\.[a-z]+$/i);
    return m ? m[1] : null;
  }

  function visibleShots() {
    return [].slice.call(root.querySelectorAll('.wp-shot:not(.is-off)'));
  }

  function filterGallery(variant) {
    var all = [].slice.call(root.querySelectorAll('.wp-shot'));
    var media = variant && variant.featured_media;
    var group = media && media.preview_image
      ? colourGroup(media.preview_image.src) : null;

    var keep = group
      ? all.filter(function (s) { return colourGroup(s.currentSrc || s.src) === group; })
      : [];
    /* a single match means the naming scheme did not apply here - show them all */
    if (keep.length < 2) keep = all;

    all.forEach(function (s) {
      var off = keep.indexOf(s) === -1;
      s.classList.toggle('is-off', off);
      var id = s.dataset.mediaId;
      root.querySelectorAll('.wp-thumb[data-media-id="' + id + '"], .wp-dot[data-media-id="' + id + '"]')
        .forEach(function (b) { b.classList.toggle('is-off', off); });
    });
  }

  function showMedia(id) {
    if (!id) return;
    var shots = visibleShots();
    var idx = 0;
    root.querySelectorAll('.wp-shot').forEach(function (img) {
      var on = img.dataset.mediaId === String(id);
      img.classList.toggle('is-active', on);
      if (on) idx = Math.max(0, shots.indexOf(img));
    });
    if (track) track.style.setProperty('--wp-i', idx);

    root.querySelectorAll('.wp-thumb, .wp-dot').forEach(function (btn) {
      var on = btn.dataset.mediaId === String(id);
      btn.classList.toggle('is-active', on);
      if (on) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });

    /* the thumb strip is a nowrap scroller now - keep the active one reachable */
    var active = root.querySelector('.wp-thumb.is-active');
    if (active && active.scrollIntoView) {
      active.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
  }

  root.querySelectorAll('.wp-thumb, .wp-dot').forEach(function (btn) {
    btn.addEventListener('click', function () { showMedia(btn.dataset.mediaId); });
  });

  /* ---------- variants ---------- */
  function selectedOptions() {
    /* index explicitly off data-option-index; DOM order is not a contract */
    var chosen = [];
    root.querySelectorAll('.wp-option').forEach(function (set) {
      var i = parseInt(set.dataset.optionIndex, 10) - 1;
      var active = set.querySelector('.wp-swatch.is-active');
      chosen[i] = active ? active.dataset.value : null;
    });
    return chosen;
  }

  function findVariant(probe) {
    return variants.filter(function (v) {
      return probe.every(function (value, i) {
        return value === null || value === undefined || v.options[i] === value;
      });
    })[0];
  }

  function markAvailability(chosen) {
    root.querySelectorAll('.wp-option').forEach(function (set) {
      var i = parseInt(set.dataset.optionIndex, 10) - 1;
      set.querySelectorAll('.wp-swatch').forEach(function (btn) {
        var probe = chosen.slice();
        probe[i] = btn.dataset.value;
        var match = findVariant(probe);
        btn.classList.toggle('is-out', !match || !match.available);
      });
    });
  }

  function apply(variant) {
    if (!variant) {
      setAdd(true, 'Unavailable');
      return;
    }

    input.value = variant.id;
    setAdd(!variant.available, variant.available ? 'Add to bag' : 'Sold out');
    priceEl.textContent = formatMoney(variant.price);

    var discounted = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.textContent = discounted ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !discounted;
    }
    if (saveEl) {
      saveEl.textContent = discounted
        ? 'Save ' + formatMoney(variant.compare_at_price - variant.price) : '';
      saveEl.hidden = !discounted;
    }
    if (badgeEl) {
      badgeEl.textContent = discounted
        ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% off'
        : '';
      badgeEl.hidden = !discounted;
    }

    if (skuWrap && skuEl) {
      if (variant.sku) { skuEl.textContent = variant.sku; skuWrap.hidden = false; }
      else { skuWrap.hidden = true; }
    }

    filterGallery(variant);
    if (variant.featured_media) showMedia(variant.featured_media.id);
    else {
      var first = visibleShots()[0];
      if (first) showMedia(first.dataset.mediaId);
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('.wp-swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var set = btn.closest('.wp-option');
      set.querySelectorAll('.wp-swatch').forEach(function (other) {
        other.classList.toggle('is-active', other === btn);
        other.setAttribute('aria-pressed', String(other === btn));
      });
      var label = set.querySelector('[data-option-selected]');
      if (label) label.textContent = btn.dataset.value;

      var chosen = selectedOptions();
      markAvailability(chosen);
      apply(findVariant(chosen));
    });
  });

  markAvailability(selectedOptions());
  /* filter the gallery for whichever colour the page loaded on */
  filterGallery(findVariant(selectedOptions()));

  /* ---------- submit spinner ---------- */
  var form = document.getElementById('wp-form');
  if (form) {
    form.addEventListener('submit', function () {
      root.querySelectorAll('.wp-add').forEach(function (b) { b.classList.add('is-busy'); });
    });
  }

  /* ---------- mobile: swipe + sticky bar ----------
     Bound through matchMedia, not a one-shot innerWidth read, so rotating the
     phone does not strand the page with the wrong engine. */
  var bar = root.querySelector('[data-sticky-bar]');
  var barShown = false;
  var swipeBound = false;
  var startX = 0, startY = 0, dragging = false, locked = false;

  function currentIndex() {
    return parseInt(track && track.style.getPropertyValue('--wp-i'), 10) || 0;
  }
  function shots() { return visibleShots(); }

  function onStart(e) {
    if (!track) return;
    var t = e.touches[0];
    startX = t.clientX; startY = t.clientY;
    dragging = true; locked = false;
    track.style.transition = 'none';
  }
  function onMove(e) {
    if (!dragging || !track) return;
    var t = e.touches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;
    if (!locked) {
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) locked = true;
      else if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
      else return;
    }
    e.preventDefault();
    track.style.transform =
      'translateX(calc(var(--wp-i, 0) * -100% + ' + dx + 'px))';
  }
  function onEnd(e) {
    if (!dragging || !track) return;
    dragging = false;
    track.style.transition = '';
    track.style.transform = '';
    if (!locked) return;
    var dx = (e.changedTouches[0].clientX - startX);
    var all = shots();
    var i = currentIndex();
    if (Math.abs(dx) > stage.offsetWidth * 0.15) {
      i = dx < 0 ? Math.min(i + 1, all.length - 1) : Math.max(i - 1, 0);
    }
    if (all[i]) showMedia(all[i].dataset.mediaId);
  }

  function checkBar() {
    if (barShown || !bar || !mq.matches) return;
    if ((window.scrollY || window.pageYOffset) > 10) {
      bar.classList.add('is-up');
      barShown = true;
      window.removeEventListener('scroll', checkBar);
    }
  }

  function arm() {
    if (mq.matches && !swipeBound && stage) {
      stage.addEventListener('touchstart', onStart, { passive: true });
      stage.addEventListener('touchmove', onMove, { passive: false });
      stage.addEventListener('touchend', onEnd, { passive: true });
      swipeBound = true;
      window.addEventListener('scroll', checkBar, { passive: true });
      checkBar();
    } else if (!mq.matches && swipeBound && stage) {
      stage.removeEventListener('touchstart', onStart);
      stage.removeEventListener('touchmove', onMove);
      stage.removeEventListener('touchend', onEnd);
      swipeBound = false;
    }
  }
  if (mq.addEventListener) mq.addEventListener('change', arm);
  else if (mq.addListener) mq.addListener(arm);
  arm();

  /* seed --wp-i from whichever shot is active on load */
  var first = root.querySelector('.wp-shot.is-active');
  if (first && track) track.style.setProperty('--wp-i', parseInt(first.dataset.mediaIndex, 10) || 0);

  /* ---------- related frames ---------- */
  (function related() {
    var section = root.querySelector('[data-related]');
    var rail = root.querySelector('[data-related-rail]');
    var id = root.dataset.productId;
    if (!section || !rail || !id) return;

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(items) {
      items = items.filter(function (p) { return String(p.id) !== String(id); }).slice(0, 10);
      if (!items.length) return;

      rail.innerHTML = items.map(function (p) {
        var imgs = (p.images || []).map(function (i) { return i && i.src ? i.src : i; });
        var img = (p.featured_image && (p.featured_image.src || p.featured_image)) || imgs[0] || '';
        var alt = imgs[1] || '';
        var name = String(p.title).split('|')[0].trim();
        var sub = String(p.title).indexOf('|') > -1
          ? String(p.title).split('|').slice(1).join('|').trim() : (p.type || '');
        var cents = typeof p.price === 'number' ? p.price
          : Math.round(parseFloat(p.variants && p.variants[0] ? p.variants[0].price : 0) * 100);
        var wasCents = typeof p.compare_at_price === 'number' ? p.compare_at_price : 0;

        return '<a class="wp-rel-card" href="' + esc(p.url || '/products/' + p.handle) + '">' +
          '<div class="wp-rel-shot">' +
            (img ? '<img class="wp-rel-img--main" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
            (alt ? '<img class="wp-rel-img--alt" src="' + esc(alt) + '" alt="" loading="lazy">' : '') +
            (p.available === false ? '<span class="wp-rel-oos">Sold out</span>' : '') +
          '</div>' +
          '<p class="wp-rel-name">' + esc(name) + '</p>' +
          '<p class="wp-rel-meta">' + esc(sub) + '</p>' +
          '<p class="wp-rel-price">' + formatMoney(cents) +
            (wasCents > cents ? '<s class="wp-rel-was">' + formatMoney(wasCents) + '</s>' : '') +
          '</p>' +
        '</a>';
      }).join('');
      section.hidden = false;
    }

    fetch('/recommendations/products.json?product_id=' + id + '&limit=10')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.products && d.products.length) { render(d.products); return; }
        throw new Error('no recommendations');
      })
      .catch(function () {
        /* a store this young has no behavioural data yet - fall back to the catalogue */
        fetch('/collections/all/products.json?limit=12')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            render((d.products || []).map(function (p) {
              return {
                id: p.id, handle: p.handle, title: p.title, type: p.product_type,
                images: (p.images || []).map(function (i) { return i.src; }),
                available: (p.variants || []).some(function (x) { return x.available; }),
                variants: p.variants
              };
            }));
          })
          .catch(function () { /* leave the rail hidden */ });
      });
  })();
})();
